<template>
    <card>
        <template #header-icon>
            <font-awesome-icon
                :icon="['fas', 'eye']"
                size="lg"
            />
        </template>
        <template #header-content>
            Review Booking
        </template>
        <template #body>
            <online-booking-checkout-review-booking />
        </template>
    </card>
</template>

<script>
    import Card from '../../../generic/card/card.vue';
    import OnlineBookingCheckoutReviewBooking from '../common/online-booking-checkout-review-booking.vue'

    export default {
        name: 'OnlineBookingCheckoutReviewBookingCard',
        components: {
            Card,
            OnlineBookingCheckoutReviewBooking,
        },
    };
</script>

<style lang="scss" scoped>
</style>
